"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const LinearProgress_1 = tslib_1.__importDefault(require("@mui/material/LinearProgress"));
const SplashMessage_1 = tslib_1.__importDefault(require("./SplashMessage"));
const SplashLoading = ({ text }) => (React.createElement(React.Fragment, null,
    React.createElement(SplashMessage_1.default, { ...{ text } }),
    React.createElement("span", null, "Loading"),
    React.createElement(LinearProgress_1.default, { color: "secondary" })));
exports.default = SplashLoading;
